// extracted by mini-css-extract-plugin
module.exports = {"instruction":"RbB-p0hhx2c0EzveT23In--instruction","info":"_2TqkCoFsUheyApi7BxYN44--info"};